import useSavedViews from "@/components/data-management/useSavedViews";

export default function SavedViewsBar({ storageKey, state, applyState, defaultState, onReset }) {
    const views = useSavedViews(storageKey, state, applyState, defaultState);

    return (
        <div className="flex flex-wrap items-center gap-2">
            <select
                value={views.activeViewId}
                onChange={(e) => views.setActiveViewId(e.target.value)}
                className="h-9 px-3 rounded-md border border-input bg-card text-sm min-w-[180px]"
            >
                <option value="">Saved views</option>
                {views.options.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
            <button type="button" onClick={views.createView} className="h-9 px-3 rounded-md border border-border bg-card hover:bg-secondary text-xs font-medium">
                Create View
            </button>
            <button type="button" onClick={views.renameView} disabled={!views.currentView} className="h-9 px-3 rounded-md border border-border bg-card hover:bg-secondary text-xs font-medium disabled:opacity-50">
                Rename
            </button>
            <button type="button" onClick={views.setDefaultView} disabled={!views.currentView} className="h-9 px-3 rounded-md border border-border bg-card hover:bg-secondary text-xs font-medium disabled:opacity-50">
                Set Default
            </button>
            <button type="button" onClick={views.deleteView} disabled={!views.currentView} className="h-9 px-3 rounded-md border border-border bg-card hover:bg-secondary text-xs font-medium disabled:opacity-50">
                Delete
            </button>
            <button type="button" onClick={() => { views.resetViews(); onReset && onReset(); }} className="h-9 px-3 rounded-md border border-border bg-card hover:bg-secondary text-xs font-medium">
                Reset Filters
            </button>
        </div>
    );
}
